import { FlexAlignValue, Sizing, Sizing2 } from 'components/Layout/types';
import { resolveSizing } from 'components/Layout/utils';
import styled from 'styled-components';
import { Box, BoxProps } from './Box';

type FlexDirectionValue =
  | 'row'
  | 'column'
  | 'row-reverse'
  | 'column-reverse'
  | 'inherit'
  | 'initial'
  | 'revert'
  | 'unset';
type FlexWrapValue = 'nowrap' | 'wrap' | 'wrap-reverse';
type JustifyContentValue = 'flex-start' | 'flex-end' | 'center' | 'space-between' | 'space-around' | 'space-evenly';
type AlignContentValue = 'flex-start' | 'flex-end' | 'center' | 'stretch' | 'space-between' | 'space-around';

export interface FlexBoxProps extends Omit<BoxProps, 'display'> {
  /** Flex-flow (equivalent to `flex-direction flex-wrap`) */
  flow?: string;
  direction?: FlexDirectionValue;
  wrap?: FlexWrapValue;

  justifyContent?: JustifyContentValue;
  alignItems?: FlexAlignValue;
  alignContent?: AlignContentValue;

  gap?: Sizing2;
  rowGap?: Sizing;
  colGap?: Sizing;
}

export const FlexBox = styled(Box)<FlexBoxProps>`
  display: flex;

  flex-flow: ${(props) => props.flow};
  flex-direction: ${(props) => props.direction};
  flex-wrap: ${(props) => props.wrap};

  justify-content: ${(props) => props.justifyContent};
  align-items: ${(props) => props.alignItems};
  align-content: ${(props) => props.alignContent};

  gap: ${(props) => resolveSizing(props.gap)};
  row-gap: ${(props) => resolveSizing(props.rowGap)};
  column-gap: ${(props) => resolveSizing(props.colGap)};
`;
